import DataLoader from 'dataloader';
import sendJson from './fetch-send';
import Cache from 'node-cache';
import { stringifyUrl } from 'query-string';

import config from '../config';

const { REF_FINANCE_API_ENDPOINT, COINGECKO_PRICE_URL, ACCOUNT_ID_SUFFIX } =
  config;

function wrapNodeCacheForDataloader(cache: any) {
  return {
    get: (...args: any) => {
      return cache.get(...args);
    },

    set: (...args: any) => {
      return cache.set(...args);
    },

    delete: (...args: any) => {
      return cache.del(...args);
    },

    clear: (...args: any) => {
      return cache.flushAll(...args);
    }
  };
}

export default class FiatValueManager {
  private coinGeckoFiatValueDataLoader: DataLoader<unknown, any, any>;

  private refFinanceDataLoader: DataLoader<unknown, any, any>;

  constructor() {
    this.coinGeckoFiatValueDataLoader = new DataLoader(
      async (tokenIds) => {
        const { result } = await sendJson(
          'GET',
          stringifyUrl({
            url: COINGECKO_PRICE_URL,
            query: {
              ids: tokenIds.join(','),
              vs_currencies: 'usd,eur,cny',
              include_last_updated_at: true
            }
          })
        );
        return tokenIds.map((id) => result[id as keyof typeof tokenIds]);
      },
      {
        cacheMap: wrapNodeCacheForDataloader(
          new Cache({ stdTTL: 30, checkperiod: 0, useClones: false })
        )
      }
    );
    this.refFinanceDataLoader = new DataLoader(
      async () => {
        const { result } = await sendJson(
          'GET',
          REF_FINANCE_API_ENDPOINT + 'list-token-price'
        );
        return [result];
      },
      {
        cacheMap: wrapNodeCacheForDataloader(
          new Cache({ stdTTL: 30, checkperiod: 0, useClones: false })
        )
      }
    );
  }

  async fetchCoinGeckoPrices(tokens = ['near', 'usn']) {
    const byTokenName: {
      [key: string]: any;
    } = {};
    const prices = await this.coinGeckoFiatValueDataLoader.loadMany(tokens);
    tokens.forEach((tokenName, ndx) => {
      const name = tokenName;
      byTokenName[name] = prices[ndx];
    });
    return byTokenName;
  }

  async fetchRefFinancePrices(dummyToken = ['near']) {
    const [prices] = await this.refFinanceDataLoader.loadMany(dummyToken);

    const last_updated_at = Date.now() / 1000;
    const formattedValues: any = Object.keys(prices).reduce(
      (acc, curr: string) => {
        const price = +Number(prices[curr]?.price);
        return {
          ...acc,
          [curr]: {
            usd: price.toFixed(2) || null,
            last_updated_at
          }
        };
      },
      {}
    );

    return {
      ...formattedValues,
      near: formattedValues[`wrap.${ACCOUNT_ID_SUFFIX}`]
    };
  }
}
